import { render, staticRenderFns } from "./tabsBar.vue?vue&type=template&id=01dbf6b8&scoped=true&"
import script from "./tabsBar.vue?vue&type=script&lang=js&"
export * from "./tabsBar.vue?vue&type=script&lang=js&"
import style0 from "./tabsBar.vue?vue&type=style&index=0&id=01dbf6b8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dbf6b8",
  null
  
)

export default component.exports